<h1 mat-dialog-title>Add new Search Filter Item</h1>

<mat-dialog-content class="dialog-content">
  <gymfinder-search-filter-item
    [(item)]="item"
    [availableFilters]="availableFilters"></gymfinder-search-filter-item>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-raised-button (click)="closeDialog()">Cancel</button>
  <button mat-raised-button color="primary" (click)="addItem()">Add</button>
</mat-dialog-actions>
